import React, { useState, useEffect } from "react";
import NavbarSidebarWrapper from "../../../components/navbarSidebarWrapper";
import actions from "../../../redux/actions";
import { useSelector } from "react-redux";
import MatkaBetResultTableList from "./MatkaBetResultTableList";

const MatkaBetResult = () => {

  const betResult = useSelector((state) => state.smBetSlice.smMyBetList?.Result);

  useEffect(() => {
    actions.getSMBetResult();
  }, []);


  return (
    <NavbarSidebarWrapper>
      <div className="content-wrapper me-0">
        {" "}
        <div className="content-header d-flex justify-content-between">
          <span className="">Bet Result</span>
        </div>
        <MatkaBetResultTableList betResultList={betResult} />
      </div>
    </NavbarSidebarWrapper>
  );
};

export default MatkaBetResult;
